<div class="modal-header">
    <div class="row">
        <div class="col-2">
            <app-branding-logo-display [useDefaultLogo]="true"></app-branding-logo-display>
        </div>
        <div class="col-8 text-center">
            <h4 class="modal-title"><b>Proof Of Delivery</b></h4>
        </div>
        <div class="col-2">
            <div class="text-end"><button type="button" class="btn btn-outline-secondary"
                    (click)="activeModal.close('Close click')">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal-body">

    @if(isLoading || !jobPodData){
    <h4>
        Loading...
    </h4>
    }@else{
    <div class="eye-view-grid-wrapper">
        <div class="row">
            <div class="col-6 mb-2">
                <div class="row eye-view-consignor-row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Freight Payer
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{ jobPodData.freightPayer}}
                    </div>
                </div>
                <div class="row eye-view-consignor-row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Delivered
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{jobPodData.deliveredDateTime | date: 'dd/MM/yyyy HH:mm'}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Reference Number
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{jobPodData.customerReference}}
                    </div>
                </div>
                <div class="row eye-view-consignor-row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        From
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{ jobPodData.fromAddressName}}
                    </div>
                </div>
                <div class="row eye-view-consignor-row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        &nbsp;
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{ jobPodData.fromAddress}}
                    </div>
                </div>

                <div class="row ">
                    <div class="col-3 mogo-bold eye-view-consignor-header">
                        &nbsp;
                    </div>
                    <div class="col-9 eye-view-consignor-content">
                        &nbsp;
                    </div>
                </div>
                <div class="row ">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Truck
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{jobPodData.truckCode}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Driver
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{jobPodData.driverName }}
                    </div>
                </div>
            </div>
            <div class="col-6 mb-2">
                <div class="row eye-view-consignor-row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Job Number
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{ jobPodData.jobNumber}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Order Number
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{jobPodData.orderNumber}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        &nbsp;
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        &nbsp;
                    </div>
                </div>
                <div class="row eye-view-consignor-row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        To
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{ jobPodData.toAddressName}}
                    </div>
                </div>
                <div class="row eye-view-consignor-row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        &nbsp;
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{ jobPodData.toAddress}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 mogo-bold eye-view-consignor-header">
                        Signed By
                    </div>
                    <div class="col-8 eye-view-consignor-content">
                        {{jobPodData?.jobPod?.signatureName || ''}}
                    </div>
                    <div class="row">
                        <div class="col-4 mogo-bold eye-view-consignor-header">
                            &nbsp;
                        </div>
                        <div class="col-8 eye-view-consignor-content">
                            &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 mb-4">
            <h5><strong>Product Details</strong></h5>
            <table class="table">
                <thead>
                    <tr>
                        <th class="bg-gray">Product Category</th>
                        <th class="bg-gray">Item Description</th>
                        @if(jobPodData.dispatchByUnits){<th class="bg-gray">Dispatch Units</th>}
                        <th class="bg-gray">
                            @if(isContractJob(jobPodData)){ {{getContractUom(jobPodData)}} }
                            @if(!isContractJob(jobPodData)){ Quantity }
                        </th>
                        @if(!isContractJob(jobPodData)){<th class="bg-gray">Weight (tonne)</th>}
                        @if(!isContractJob(jobPodData)){<th class="bg-gray">Volume (m3)</th>}
                    </tr>
                </thead>
                @if(!isContractJob(jobPodData)){
                <tbody>
                    @for(product of jobPodData.jobProducts; track $index){
                    <tr>
                        <td [attr.rowspan]="product?.productItems?.length + 1">
                            {{product?.productCategory?.name
                            || ''}}
                        </td>
                    </tr>
                    @for(item of product.productItems; track $index){
                    <tr>
                        <td>{{ item.itemDescription }}</td>
                        @if(jobPodData.dispatchByUnits){<td>&nbsp;</td>}
                        <td>{{ item.quantity }}</td>
                        <td>{{ item.weight}}</td>
                        <td>{{ item.volume}}</td>
                    </tr>
                    }
                    }
                </tbody>
                }@else{
                <tbody>
                    @for(product of jobPodData.jobProducts; track $index){
                    <tr>
                        <td>
                            <b>{{product?.productCategory?.name
                                || ''}}</b>
                        </td>
                        <td>{{ product.productDescription }}</td>
                        @if(jobPodData.dispatchByUnits) {<td>{{
                            product.dispatchQuantity }}</td>}
                        <td>{{ product.quantity }}</td>
                        @if(!isContractJob(jobPodData)){ <td></td> }
                        @if(!isContractJob(jobPodData)){ <td></td> }
                    </tr>
                    }
                </tbody>
                }
            </table>
        </div>

        @if(jobPodData && jobPodData.jobPod){
        <div class="col-12 mb-2">
            <div #deliverylocationmap id="delivery-location-map" style="height: 200px;"></div>
        </div>
        }

        <div class="col-12 mb-4">
            <h5><strong>Proof of Deliveries</strong></h5>
            @if(isPodImageLoading){
            <div class="d-flex">
                <div class="spinner-grow text-highlight-color m-3" role="status">
                </div>
                <p class="mogo-bold mt-4">Loading...</p>
            </div>
            }@else {
            @if(orderImagesString && orderImagesString.length > 0){
            <div class="row">
                @for(image of orderImagesString; track $index){
                @if(image && image.contentType === 'application/pdf'){
                <div class="col-1 text-center">
                    <a [href]="image.href" target="_blank">
                        <i class="b-fa b-fa-file-pdf b-fa-3x" aria-hidden="true"></i>
                    </a>
                </div>
                }@else {
                <div class="col-1">
                    <a [href]="image.href" target="_blank">
                        <img width="90" [src]="image.base64" alt="Proof of Delivery" />
                    </a>
                </div>
                }
                }
            </div>
            }@else {
            <p class="mogo-bold">No POD image to show</p>
            }
            }
        </div>
    </div>
    }
</div>
<div class="modal-footer">
    <div class="col-11 flex-fill">
        @if(sendEmailForm !== undefined && sendEmailForm !== null){
        <div class="flex-fill">
            <form [formGroup]="sendEmailForm" class="d-inline-flex w-50">
                <ng-select formControlName="recipients" [items]="[]" [addTag]="addTag" [multiple]="true"
                    [selectOnTab]="true" [isOpen]="false" placeholder="Enter email addresses"
                    notFoundText="Type to add a valid email" class="w-100">
                </ng-select>

                <button class="btn btn-primary" style="margin-left: 10px;" (click)="sendEmail()"
                    [disabled]="emailFormControl.value.length === 0">
                    Send
                </button>
            </form>
            <button type="button" class="btn btn-primary" style="margin-left: 10px;"
                (click)="downloadPodClick()">Download</button>
        </div>
        }
    </div>
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Close</button>
</div>